<template>
  <section class="block-main">
    <div class="block-main__container container">
      <div class="block-main__content">
        <div class="block-main__text-wrapper">
          <p class="block-main__text">Дни продаж в Автомир. Только {{ date }}!</p>

          <h1 class="block-main__title">
            Новый <b>GEELY</b> от <b>{{ payment }}</b> ₽/месяц<br/>
            Рекордная выгода до <span><b>{{ benefit }}</b> рублей!</span><br/>
          </h1>
          
          <h2 class="block-main__subtitle">
            <b>Рассрочка!</b> Щедрые <b>подарки</b> от дилера!
          </h2>
          <h2 class="block-main__subtitle">
            Успейте до повышения  <b>утильсбора!</b>
          </h2>
        </div>

        <button
          class="block-main__btn button button_theme_primary"
          @click="getCall"
        >
        Зафиксировать условия по акции
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import Mixin from "../common/mixin";
import { formatDate } from "../common/date";
import { MAX_BENEFIT, MIN_PAYMENTS } from "@/common/cars-info";

export default {
  name: "block-main",
  mixins: [Mixin],
  data() {
    function getDate(period) {
      return `с ${formatDate(period.start, 'shortNumber')} до ${formatDate(period.end, 'shortNumber')}`;
    };

    const date = getDate(this.CONSTANTS.period);

    return {
      date,
      benefit: MAX_BENEFIT,
      payment: MIN_PAYMENTS
    };
  },
  methods: {
    handleCallback(data) {
      this.$emit("callBack", data);
    },
  },
};
</script>

<style scoped lang="scss">
@import "../styles/constants.scss";

.block-main {
  background-image: url("../images/background/main.webp");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 100% 75%;
  height: calc(800 / 1920 * 100vw);
  max-height: 800px;
  overflow: hidden;
  padding-top: 25px;
  font-size: 20px;

  &__container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding-top: 1em;
  }

  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 auto;
  }

  &__text-wrapper {
    width: fit-content;
    background-color: rgba(255, 255, 255, 0.75);
    padding: 1.5em 1em 1em;
    text-align: center;
    border-radius: 0.75em;
  }

  &__text {
    background-color: #fff;
    color: #000;
    font-size: 1em;
    font-weight: 700;
    padding: 7px 20px;
    border-radius: 10px;
    margin: 0 auto;
    margin-top: -1.5em;
    max-width: max-content;
    transform: translateY(-50%);
    text-align: center;
  }
  
  &__title {
    font-size: 2em;
    font-weight: 500;
    line-height: 1.2;
    margin-bottom: 0.25em;

    b {
      font-weight: 700;
    }

    span {
      white-space: nowrap;
    }
  }

  &__subtitle {
    font-size: 1.1em;
    text-transform: uppercase;
    font-weight: 500;
    
    &:not(:first-child) {
      margin-top: 0.25em;
    }

    b {
      font-weight: 700;
    }
  }

  &__btn {
    width: auto;
    min-width: 300px;
    padding: 1.18em;
    font-size: 1em;
    margin-top: 0.68em;
    height: auto;
  }

  &__img {
    display: none;
  }
}

@media (max-width: 1920px) {
  .block-main {
    font-size: calcFontSize(14, 20, 640, 1920);
  }
}

@media (max-width: 800px) {
  .block-main {
    height: calc(100vw * 600 / 800);
    text-align: center;
    padding-top: 15px;

    &__container {
      align-items: center;
    }
  }
}

@media (max-width: 640px) {
  .block-main {
    background-image: url("../images/background/main_m.webp");
    background-position: center;
    min-height: calc(100vw * 325 / 323);
    font-size: calcFontSize(12, 23, 360, 640);

    &__title {
      font-size: 1.6em;
    }

    &__subtitle {
      font-size: 1em;
    }
  }
}
</style>
